export default __webpack_public_path__ + "static/media/feather.840420dc.PNG";